import { EntityMutationConfig } from '@/hooks/useEntityMutation';
import { ClientsService, Client } from '@/services/clients';

/**
 * Configuració per mutations de Client
 */
export const clientMutationConfig: EntityMutationConfig<Client> = {
  entity: 'client',
  service: ClientsService,
  queryKey: ['clients'],
  messages: {
    createSuccess: 'Client creat correctament',
    updateSuccess: 'Client actualitzat correctament',
    deleteSuccess: 'Client eliminat correctament',
    createError: 'Error en crear el client',
    updateError: 'Error en actualitzar el client',
    deleteError: 'Error en eliminar el client',
  },
};
